import { render, staticRenderFns } from "./home_tab.vue?vue&type=template&id=1eaefc04&scoped=true"
import script from "./home_tab.vue?vue&type=script&lang=js"
export * from "./home_tab.vue?vue&type=script&lang=js"
import style0 from "./home_tab.vue?vue&type=style&index=0&id=1eaefc04&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eaefc04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eaefc04')) {
      api.createRecord('1eaefc04', component.options)
    } else {
      api.reload('1eaefc04', component.options)
    }
    module.hot.accept("./home_tab.vue?vue&type=template&id=1eaefc04&scoped=true", function () {
      api.rerender('1eaefc04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/home_tab.vue"
export default component.exports